import { render } from "./install-app.vue?vue&type=template&id=23095be3&scoped=true"
import script from "./install-app.vue?vue&type=script&setup=true&lang=js"
export * from "./install-app.vue?vue&type=script&setup=true&lang=js"

import "./install-app.vue?vue&type=style&index=0&id=23095be3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23095be3"],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/salla/install-app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23095be3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23095be3', __exports__)) {
    console.log('reload')
    api.reload('23095be3', __exports__)
  }
  
  module.hot.accept("./install-app.vue?vue&type=template&id=23095be3&scoped=true", () => {
    console.log('re-render')
    api.rerender('23095be3', render)
  })

}


export default __exports__